"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));

var _react = _interopRequireDefault(require("react"));

require("./TaskLikertScale.scss");

var _reactBootstrap = require("react-bootstrap");

var _DesignComponents = require("../DesignComponents/DesignComponents");

var _CompletedContext = require("../CompletedContext");

var TaskLikertScale = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(TaskLikertScale, _React$Component);

  var _super = (0, _createSuper2.default)(TaskLikertScale);

  function TaskLikertScale(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TaskLikertScale);
    _this = _super.call(this, props);
    _this.state = props.state || {};

    if (!_this.state.initialized) {
      _this.state.initialized = true; // Initial state is set here, since the constructor can be called more than once.

      _this.state.completed = false;
      _this.state.value = props.initialValue;
    }

    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(TaskLikertScale, [{
    key: "isTask",
    value: function isTask() {
      return true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevprops, prevstate, snapshot) {
      if (prevstate.completed !== this.state.completed || prevstate.taskId !== this.state.taskId) {
        // Make sure our parent knows about the completion
        this.context.onCompleted(this.state.completed, this.state.taskId);
      }

      for (var _i = 0, _Object$keys = Object.keys(this.state); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];

        // Keep our stored state synchronized
        if (this.state[key] !== this.props.state[key]) {
          this.props.state[key] = this.state[key];
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // Notify the parent of our completion status
      this.context.registerTask(function (id) {
        _this2.setState({
          taskId: id
        });
      });
      this.context.onCompleted(this.state.completed, this.state.taskId);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.resetValue === true) {
        this.setState({
          value: this.props.initialValue
        });
      }
    }
  }, {
    key: "perc",
    value: function perc(n) {
      return (n * 100).toFixed(3) + "%";
    }
  }, {
    key: "handleChange",
    value: function handleChange(i) {
      this.setState({
        completed: this.props.withSubmit ? this.state.completed : true,
        value: i
      });

      if (this.props.onChange) {
        this.props.onChange(i);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this,
          _this$props$marginRig;

      var inputs = [];
      var labels = [];

      var _loop = function _loop(i) {
        inputs.push( /*#__PURE__*/_react.default.createElement("input", {
          className: "likert-radio-button",
          type: "radio",
          value: i + 1,
          name: "a",
          key: "radioslider-radio-" + i,
          id: "radioslider-radio-" + i,
          checked: _this3.state.value === i,
          onChange: function onChange() {
            _this3.handleChange(i);
          },
          style: {
            '--radio-width': _this3.perc(1 / _this3.props.intervals)
          },
          "aria-labelledby": "radioslider-label-" + i
        }));

        if (_this3.props.labels) {
          // MAKE THESE label ELEMENTS
          labels.push( /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
            key: "radioslider-label-" + i,
            style: {
              padding: 0
            }
          }, /*#__PURE__*/_react.default.createElement("label", {
            htmlFor: "radioslider-radio-" + i
          }, _this3.props.labels[i])));
        }
      };

      for (var i = 0; i < this.props.intervals; i++) {
        _loop(i);
      }

      if (!this.props.legend) {}

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "task task-likert-scale"
      }, /*#__PURE__*/_react.default.createElement("p", null, this.props.prompt), /*#__PURE__*/_react.default.createElement("small", null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
        className: "flex-nowrap",
        style: {
          textAlign: "center",
          margin: "0px 0px"
        }
      }, labels)), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          height: '24px',
          margin: '10px 0px 10px 0px'
        }
      }, /*#__PURE__*/_react.default.createElement("form", null, /*#__PURE__*/_react.default.createElement("fieldset", null, /*#__PURE__*/_react.default.createElement("legend", {
        className: "sr-only"
      }, this.props.legend), /*#__PURE__*/_react.default.createElement("div", {
        className: "likert-radio-bar form-group",
        role: "radiogroup",
        style: {
          '--progress': this.perc(this.state.value / (this.props.intervals - 1)),
          '--radio-width': this.perc(1 / this.props.intervals)
        }
      }, inputs)))), this.props.withSubmit && /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'end',
          marginTop: "16px",
          marginRight: (_this$props$marginRig = this.props.marginRight) !== null && _this$props$marginRig !== void 0 ? _this$props$marginRig : "20px"
        }
      }, /*#__PURE__*/_react.default.createElement(_DesignComponents.Button, {
        className: "bdg-submit-button",
        type: "submit",
        disabled: this.state.completed || this.state.value === undefined,
        onClick: function onClick(e) {
          if (_this3.state.value !== undefined) {
            _this3.setState({
              completed: true
            });
          }
        }
      }, /*#__PURE__*/_react.default.createElement("b", null, "Submit"))));
    }
  }]);
  return TaskLikertScale;
}(_react.default.Component);

exports.default = TaskLikertScale;
TaskLikertScale.contextType = _CompletedContext.CompletedContext;